<div class="text-center">
  <mat-card class="card1">
    <mat-card-content class="text-center">
      <img [src]="environment.login.logo || 'assets/images/logo-ivcert.png'" alt="Logo">
    </mat-card-content>
  </mat-card>
  <mat-card class="card2">
    <mat-card-header>
      <mat-panel-title [style.color]="'primary'|colors" class="title">
        {{ 'register_form_user_title' | translate:_transParam }}
      </mat-panel-title>
    </mat-card-header>
    <br>
    <mat-card-content>
      <div class="full-width">
        <div class="text-center">
          <iv-form #formUser id="register-form-user" name="register-form-user" [errorsForm]="erroresForm"
            [title]="'register_form_user_title' | translate:_transParam " [(columnsForm)]="configFormUser" [colNo]="3">
          </iv-form>
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions>
      <div class="full-width text-center">
        <button (click)="clear()" id="clear-form" name="clear-form" type="button" [color]="'material'|colors"
          [style.color]="'primary'|colors" mat-stroked-button>
          {{'btn_limpiar' | translate:_transParam }}
        </button>
        <button [disabled]="!formUser.Form.valid" (click)="submit()" id="submit-form" name="submit-form" type="button"
          [color]="'material'|colors" [style.background-color]="'primary'|colors" [style.color]="'text'|colors"
          mat-raised-button>
          {{'btn_guardar' | translate:_transParam }}
        </button>
        <button (click)="fillForm()" id="upload-certificate" name="upload-certificate" type="button"
          [color]="'material'|colors" [style.background-color]="'primary'|colors" [style.color]="'text'|colors"
          mat-raised-button>
          {{ 'register_btn_certificate' | translate:_transParam }}
        </button>
      </div>
    </mat-card-actions>
  </mat-card>

  <button id="rtrn" (click)="toHome()" mat-flat-button [color]="'material'|colors"
    [style.background-color]="'primary'|colors" [style.color]="'text'|colors">{{'btn_return_home' |
    translate:_transParam }}
  </button>
</div>
